module.exports = __webpack_public_path__ + "img/vehicle-slides-with-backdrop-hyundai.6740e233.png";